const toDoData = {
  name: "Advanced To-Do List",
  description:
    "Introducing a advanced To-Do List Chrome Extension designed to help you focus on what matters. Perfect for everyday tasks, reminders, or office checklists.",
  label: "How to Use",
  usage: [
    "Enter a task and press Add to add it to the list.",
    "Set up a ckeckbox to mark it as completed.",
    "Click the ✏️ icon next to a task to edit it.",
    "Click 📋 to copy the task text to clipboard.",
    "Click the ⚪ icon next to a task to change its background.",
    "Click ❌ to delete a task from the list.",
    "Drag and drop tasks to reorder them.",
  ],

  btnBack: "Back",
};

export default toDoData;
